import { render, staticRenderFns } from "./WorkflowFormFormio.vue?vue&type=template&id=5fc1a7be"
import script from "./WorkflowFormFormio.vue?vue&type=script&lang=js"
export * from "./WorkflowFormFormio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports